import { useEffect } from 'react';

/**
 * Sends a paginated table back to its last page once the list shrinks below the current page
 * (removing or restoring the only rows of a page would otherwise strand the view on an empty
 * page without pagination). Waits for `isReady`: while a request is in flight the page count is
 * stale and would clamp a legitimate page away.
 *
 * @param {Object} params
 * @param {number} params.page - Current 1-based page
 * @param {number} params.totalPages - Page count of the current result (0 when empty)
 * @param {(page: number) => void} params.setPage
 * @param {boolean} params.isReady - The page count belongs to the current request
 * @returns {void}
 */
export function useClampPage({ page, totalPages, setPage, isReady }) {
	useEffect(() => {
		const lastPage = Math.max(1, totalPages);
		if (isReady && page > lastPage) setPage(lastPage);
	}, [page, totalPages, setPage, isReady]);
}
